// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-info-title[data-v-7632c5e6]{font-weight:700;margin-top:5px}", ""]);
// Exports
module.exports = exports;
